import { Input } from '@bitcine/cinesend-theme'
import { useState } from 'react'

const ChildSortPriority = ({ field, saveField }) => {
  const [value, setValue] = useState(field.child_sort_priority ?? '')
  return (
    <Input
      label={{ text: 'Child sort priority' }}
      width='w-36'
      type='number'
      min={1}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      step={1}
      onBlur={(e) => {
        const raw = e.target.value
        if (raw === '') {
          saveField({ child_sort_priority: null })
          return
        }
        const num = Number(raw)
        if (!Number.isInteger(num) || num < 1) {
          setValue(field.child_sort_priority ?? '')
          return
        }
        saveField({ child_sort_priority: num })
      }}
    />
  )
}

export default ChildSortPriority
